// Les liens envoyés aux membres (D-104, Idries : « La page publique et l'app doivent être sous le
// sous-domaine du club »). Un club qui a une adresse (clubs.public_slug) a son sous-domaine
// <adresse>.<base> (bcl.arceau.app), même page publique hors ligne : l'app y est en /app, avec
// l'icône et le nom du club dès la première ouverture. Sans adresse (ou sans base) : l'adresse
// actuelle de l'app.
import { RESERVED_SLUGS, SLUG } from './slug';

export interface Here { protocol: string; host: string; port: string; origin: string; pathname: string }
export interface ClubLinks { origin: string; onClubHost: boolean; app: string; invite: (token: string) => string }

/** L'origine où ouvrir les liens d'un club : https://bcl.arceau.app, sinon l'origine actuelle. */
export function clubOrigin(slug: string | null | undefined, hostBase: string | null | undefined, here: Here): { origin: string; onClubHost: boolean } {
  const base = (hostBase ?? '').trim().toLowerCase().replace(/^\.+/, '');
  const s = (slug ?? '').trim().toLowerCase();
  if (!base || !SLUG.test(s) || RESERVED_SLUGS.includes(s)) return { origin: here.origin, onClubHost: false };
  return { origin: `${here.protocol}//${s}.${base}${here.port ? `:${here.port}` : ''}`, onClubHost: true };
}

/** L'app du club (/app sur son sous-domaine), le lien d'invitation (/i/<jeton>). */
export function clubLinks(slug: string | null | undefined, hostBase: string | null | undefined, here: Here): ClubLinks {
  const { origin, onClubHost } = clubOrigin(slug, hostBase, here);
  const app = onClubHost ? `${origin}/app/` : `${origin}${here.pathname.startsWith('/app') ? '/app' : ''}/`;
  return { origin, onClubHost, app, invite: (token: string) => `${origin}/i/${token}` };
}
